/* eslint-disable no-unused-vars */
import * as Mutations from "./mutation-types";
import * as Actions from "./action-types";
import * as api from "@/api/api";
import * as utils from "@/api/utils";
import * as Helpers from "@/helpers";
import { executeQueryHelper } from "@/store/CommonStoreHelpers";

const defaultStreamingRoFQuery = {
  keys: [],
  return_type: "absolute",
  aggregation_type: "cumulative",
  reach_criteria: "1",
  max_frequencies: 10,
  displayColumns: [],
  panel_date: "",
  target_group: {},
  rofVariant: ""
};
const defaultStreamingQuery = {
  start_date: "",
  end_date: "",
  domainGroups: [],
  reachCriteria: "1",
  columns: [],
  displayColumns: [],
  dayparts: [],
  target_group: [],
  weekdays: []
};
const state = {
  streamingInitStatus: "NOT_LOADED",
  streamingColumnTypes: [],
  queryCost: {
    data: null,
  },
  streamingSelectedResults: [],
  streamingQuery: {
    ...defaultStreamingQuery
  },
  defaultStreamingQuery: {
    ...defaultStreamingQuery
  },
  streamingQueryForAPI: {
    start_date: "",
    end_date: "",
    domainGroups: [],
    reachCriteria: "1",
    columns: [],
    displayColumns: [],
    dayparts: [],
    target_group: []
  },
  streamingRoFQuery: { ...defaultStreamingRoFQuery },
  streamingColumnFieldsOptions: [],
  streamingDisplayColumnFieldsOptions: [],
  streamingResults: {
    status: "NOT_LOADED"
  },
  streamingRoFResults: {
    status: "NOT_LOADED"
  },
  streamingSumVisible: false,
  streamingRoFResultsLoadDetails: false,
  streamingDomainGroups: [],
  streamingAllWithStarSelected: false,
  streamingRofMaxFreqOptions: Array.from(new Array(20).keys()).map(idx => ({
    text: `${idx + 1}`,
    value: idx + 1
  }))
};
const convertFromQueryToQueryForAPI = ctx => {
  let query = {
    ...state.streamingQuery
  };
  // om alla * är valda, släng in alla nyckelkolumner, annars skiter vi i det
  let keycolumn = null;

  if (state.streamingAllWithStarSelected) {
    keycolumn = state.streamingColumnTypes.filter(col => col.key)[0];
    let keyExists = query.columns.some(c =>
      c.display_name.toLowerCase().includes("key")
    );
    if (!keyExists) {
      let keyColumns = state.streamingColumnTypes
        .filter(function(c) {
          if (c.display_name.toLowerCase().includes("key")) return c;
        })
        .map(col => ({
          column_type: col.column_type,
          display_name: col.display_name
        }));
      //query.columns.push(...keyColumns);
    }
  } else {
    //query.columns = query.columns.filter(function(c) {
    //  if (!c.display_name.toLowerCase().includes("key")) return c;
    //});

    keycolumn = {
      column_type: null,
      display_name: null
    };
  }

  // if no columns are selected, use all columns
  if (!query.columns || query.columns.length === 0) {
    query.columns = state.streamingColumnTypes
      .filter(x => x.hidden == false || x.default_selection == true)
      .map(col => ({
        column_type: col.column_type,
        display_name: col.display_name
      }));
  }

  // Add alwaysIncludeInGroupBy columns if they don't already exist
  query.columns = query.columns.concat(
    state.streamingColumnTypes
      .filter(
        col =>
          col.alwaysIncludeInGroupBy &&
          !query.columns.some(c => c.column_type === col.column_type)
      )
      .map(col => ({
        column_type: col.column_type,
        display_name: col.display_name
      }))
  );

  query.key_column = {
    column_type: keycolumn.column_type,
    display_name: keycolumn.display_name
  };

  if (query.weekdays) query.weekday_numbers = query.weekdays;
  let dayparts = query.dayparts;
  query.day_parts = utils.splitDayParts(dayparts);
  if (query.reachCriteria) query.reach_criteria = query.reachCriteria;
  let targetGroups = query.target_group;
  query.measures = targetGroups.length > 0
    ? targetGroups.map(measure => {
      
      let columnType = measure.measure.column_type;
      if(measure.targetDevice === "bigScreen")
        columnType = measure.measure.bigscreen.column_type;
      else if(measure.targetDevice === "digitalDevices")
        columnType = measure.measure.digitaldevices.column_type;

      let targetGroup = {
        group: measure.group == 'W' ? 'K' : measure.group,
        age_from: measure.age_from,
        age_to: measure.age_to
      };

      // Add Other target group fields if group is "O"
      if (measure.group === 'O' && measure.othertargetgroups && measure.othertargetgroupsvalues) {
        targetGroup.other_category = measure.othertargetgroups;
        targetGroup.other_value = measure.othertargetgroupsvalues;
      }

      // Build display_name
      let displayName = measure.selectedMeasureText.header;
      displayName += `\n${measure.selectedMeasureText.subHeader}`;

      let newMeasure = {
        target_group: targetGroup,
        min_viewing_time: measure.reach_criteria,
        consolidated: measure.timeshift.consolidated,
        days: measure.timeshift.days,
        timeshift: measure.timeshift.keys,
        display_name: displayName,
        column_type: columnType,
        tooltip: measure.tooltip
      };
      return newMeasure;
    })
    : [];
  query.rows_per_page = 2147483647;
  query.tab = "streaming";
  let {
    weekdays,
    reachCriteria,
    target_group,
    dayparts: omitted,
    ...queryOmittedProps
  } = query;
  return queryOmittedProps;
};
const setInitialRofTableColumns = context => {
  let initialRofTableColumns = [];
  let rofQuery = context.getters.getStreamingRoFQuery;
  const maxNbrFreq = Math.min(
    rofQuery.max_frequencies,
    context.getters.getStreamingRoFResults.data.frequency_matrix.length
  );
  let rofResultReachHeaderText =
    rofQuery.return_type === "absolute"
      ? "Net Reach 1+ 000s"
      : "Net Reach 1+ %";
  let rofResultRatingHeaderText =
    rofQuery.return_type === "absolute" ? "Rating 000s" : "Rating %";
  initialRofTableColumns = [
    { key: "domainGroups", label: "Media companies", tdClass: "smallfontsize" },
    { key: "targetGroup", label: "Target group", tdClass: "text-right" },
    { key: "universeNumber", label: "Universe", tdClass: "text-right" },
    {
      key: "reach",
      label: rofResultReachHeaderText,
      thClass: "text-right rofreachheaderwidth",
      tdClass: "text-right"
    },
    {
      key: "average_frquency",
      label: "Avg Freq",
      thClass: "text-right rofavgfreqheaderwidth",
      tdClass: "text-right"
    },
    {
      key: "rating",
      label: rofResultRatingHeaderText,
      tdClass: "text-right",
      thClass: "text-right rofratingheaderwidth"
    }
  ];
  for (let idx = 0; idx < maxNbrFreq; idx++) {
    if (context.getters.getStreamingRoFResults.data.isCumulative)
      initialRofTableColumns.push({
        key: `F${idx + 1}`,
        label: `F${idx + 1}+`,
        thClass: "text-right fwidth",
        tdClass: "text-right"
      });
    else
      initialRofTableColumns.push({
        key: `F${idx + 1}`,
        label: `F${idx + 1}`,
        thClass: "text-right fwidth",
        tdClass: "text-right"
      });
  }
  context.commit(Mutations.setStreamingRoFResults, {
    ...context.getters.getStreamingRoFResults,
    initialRofTableColumns
  });
};
const setInitialRofTableRow = context => {
  let query = context.getters.getStreamingRoFQuery;
  const maxNbrFreq = Math.min(
    query.max_frequencies,
    context.getters.getStreamingRoFResults.data.frequency_matrix.length
  );
  let targetLabel = context.getters.getStreamingRoFResults.targetGroup;
  let chosenStreams = context.getters.getStreamingResults.data.rows.filter(
    s => s.selected
  );

  // get the key of domaingroup
  let domainGroupKey = context.getters.getStreamingRoFResults.initialRofTableColumns.find(
    c => c.key === "domainGroups"
  ).label;

  let uniqueChannelNames = [
    ...new Set(chosenStreams.map(item => item[domainGroupKey]))
  ].sort();
  let expandTheseInitialRoFTableColumns = [
    {
      expanded: false,
      slotName: "domainGroups",
      shortList: "",
      fullList: ""
    }
  ];
  expandTheseInitialRoFTableColumns[0].shortList = Helpers.takeElementsUpTo100Chars(
    uniqueChannelNames
  ).join(", ");
  expandTheseInitialRoFTableColumns[0].fullList = uniqueChannelNames.join(", ");
  let lastRofRowReach = context.getters.getStreamingRoFResults.data.reach_1_plus_acc.slice(
    -1
  )[0];
  let lastRofRowRating = context.getters.getStreamingRoFResults.data.rating.slice(
    -1
  )[0];
  let freqMatrix = context.getters.getStreamingRoFResults.data.frequency_matrix
    .slice(-1)[0]
    .slice(0, query.max_frequencies);
  let freqMatrixObj = {};
  if (query.return_type === "absolute") {
    lastRofRowReach = Math.round(lastRofRowReach / 1000).toLocaleString("sv");
    lastRofRowRating = Math.round(lastRofRowRating / 1000).toLocaleString("sv");
    for (let i = 0; i < maxNbrFreq; i++) {
      freqMatrixObj[`F${i + 1}`] = Math.round(
        freqMatrix[i] / 1000
      ).toLocaleString("sv");
    }
  } else {
    lastRofRowReach = (lastRofRowReach * 100).toFixed(1);
    lastRofRowRating = (lastRofRowRating * 100).toFixed(1);
    for (let i = 0; i < maxNbrFreq; i++) {
      freqMatrixObj[`F${i + 1}`] = (freqMatrix[i] * 100).toFixed(1);
    }
  }
  let lastRofRowAvgFreq = context.getters.getStreamingRoFResults.data.average_frquency.slice(-1)[0];
  let initialRofTableRow = [
    {
      domainGroups: uniqueChannelNames.join(", "),
      targetGroup: targetLabel,
      universeNumber: context.getters.getStreamingRoFResults.data.universalNumber.toLocaleString(
        "sv"
      ),
      reach: lastRofRowReach,
      average_frquency: lastRofRowAvgFreq,
      rating: lastRofRowRating,
      ...freqMatrixObj
    }
  ];
  context.commit(Mutations.setStreamingRoFResults, {
    ...context.getters.getStreamingRoFResults,
    initialRofTableRow
  });
  context.commit(Mutations.setStreamingRoFResults, {
    ...context.getters.getStreamingRoFResults,
    expandTheseInitialRoFTableColumns
  });
};
const setRofTableColumns = context => {
  let rofTableColumns = [];
  let query = context.getters.getStreamingRoFQuery;
  const maxNbrFreq = Math.min(
    query.max_frequencies,
    context.getters.getStreamingRoFResults.data.frequency_matrix.length
  );
  let freq_array = [];

  for (let idx = 0; idx < maxNbrFreq; idx++) {
    if (context.getters.getStreamingRoFResults.data.isCumulative)
      freq_array.push({
        key: `F${idx + 1}`,
        label: `F${idx + 1}+`,
        thClass: "text-right fwidth",
        tdClass: "text-right"
      });
    else
      freq_array.push({
        key: `F${idx + 1}`,
        label: `F${idx + 1}`,
        thClass: "text-right fwidth",
        tdClass: "text-right"
      });
  }
  let cols = context.getters.getStreamingQuery.displayColumns.map(c => c.column_type);
  let selectedColumns = context.getters.getStreamingColumnTypes
    .filter(function(column) {
      if (!column.hidden && cols.includes(column.column_type)) return column;
    })
    .map(c => ({
      key: c.display_name,
      label: c.display_name
    }));
  let initialRofTableColumns =
    context.getters.getStreamingRoFResults.initialRofTableColumns;

  rofTableColumns = [
    ...selectedColumns,
    {
      key: `reach_1_plus_acc`,
      label: initialRofTableColumns.find(c => c.key === "reach").label,
      thClass: "text-right rofreachheaderwidth",
      tdClass: "text-right"
    },
    {
      key: `average_frquency`,
      label: `Avg Freq`,
      thClass: "text-right rofavgfreqheaderwidth",
      tdClass: "text-right"
    },
    {
      key: `rating`,
      label: initialRofTableColumns.find(c => c.key === "rating").label,
      thClass: "text-right rofratingheaderwidth",
      tdClass: "text-right"
    },
    ...freq_array
  ];
  context.commit(Mutations.setStreamingRoFResults, {
    ...context.getters.getStreamingRoFResults,
    rofTableColumns
  });
};
const setRofTableRows = context => {
  const keys = context.getters.getStreamingRoFResults.data.keys;
  let query = context.getters.getStreamingRoFQuery;
  const reach_1_plus_acc = context.getters.getStreamingRoFResults.data.reach_1_plus_acc.map(
    x => ({
      reach_1_plus_acc:
        query.return_type === "absolute"
          ? Math.round(x / 1000).toLocaleString("sv")
          : (x * 100).toFixed(1)
    })
  );
  const average_frquency = context.getters.getStreamingRoFResults.data.average_frquency.map(
    x => ({ average_frquency: x })
  );
  const rating = context.getters.getStreamingRoFResults.data.rating.map(x => ({
    rating:
      query.return_type === "absolute"
        ? Math.round(x / 1000).toLocaleString("sv")
        : (x * 100).toFixed(1)
  }));
  let highestFreq = Math.max(
    ...context.getters.getStreamingRofMaxFreqOptions.map(o => o.value)
  );
  let rofTableRows = context.getters.getStreamingRoFResults.data.frequency_matrix.map(
    (row, id) => {
      const freqRow = row.slice(0, highestFreq).reduce((prev, cur, freqIdx) => {
        cur =
          query.return_type === "absolute"
            ? Math.round(cur / 1000).toLocaleString("sv")
            : (cur * 100).toFixed(1);
        return {
          ...prev,

          // visa inget värde på rad/frekv som inte kan ha ngt värde
          [`F${freqIdx + 1}`]: freqIdx > id ? null : cur
        };
      }, {});

      return {
        // lägg till rad från analysfliken
        ...context.getters.getStreamingResults.data.rows.filter(
          r => r.STREAMING_COMPOSITE_KEY == keys[id]
        )[0],
        ...freqRow,
        ...reach_1_plus_acc[id],
        ...average_frquency[id],
        ...rating[id]
      };
    }
  );
  context.commit(Mutations.setStreamingRoFResults, {
    ...context.getters.getStreamingRoFResults,
    rofTableRows
  });
};
const actions = {
  [Actions.getStreamingColumnTypes]: async () => {
    return await api.getColumnTypes("STREAMING");
  },
  [Actions.getStreamingMeasures]: async () => {
    return await api.getMeasures("STREAMING");
  },
  [Actions.getStreamingTimeshift]: async () => {
    const timeshift = await api.getTimeshiftForStreaming();
    return timeshift;
  },
  [Actions.getStreamingDomainGroups]: async () => {
    return await api.getStreamingDomainGroups();
  },
  [Actions.executeStreamingScheduleQuery]: async (
    context, reportname
  ) => {
    const query = convertFromQueryToQueryForAPI();
    await api.createScheduledReportQuery(reportname, query);

  },
  [Actions.executeExportStreamingQuery]: async (
    context
  ) => {
    const query = convertFromQueryToQueryForAPI();
    query.excludedRows = []
    return await api.executeExportQuery(query);
  },
  [Actions.executeStreamingQuery]: async context => {
    let showSum = false;
    let streamingResult = context.getters.getStreamingResults;

    if (streamingResult.status == "LOADED") {
      if (streamingResult.data.hasExcludedStream) showSum = true;
    }
    context.commit(Mutations.setStreamingResults, {
      status: "LOADING",
      data: null
    });

    // Check for all star selected
    const selColumns = context.getters.getStreamingQuery.columns;
    const columnFieldsOptions = context.getters.getStreamingColumnFieldsOptions;
    const allStarSelected = Helpers.allWithStarsSelected(
      selColumns,
      columnFieldsOptions
    );
    context.commit(Mutations.setStreamingAllWithStarSelected, allStarSelected);

    // Update the query with current state before sending to API
    const queryForApi = {
      ...context.getters.getStreamingQuery
    };

    // If displayColumns is empty, use the same as columns like in channels module
    if (
      !queryForApi.displayColumns ||
      queryForApi.displayColumns.length === 0
    ) {
      queryForApi.displayColumns = [...queryForApi.columns];
    }

    context.commit(Mutations.setStreamingQueryForAPI, queryForApi);

    const query = convertFromQueryToQueryForAPI();

    try {
      const queryCostData = await api.getQueryCost(query);
      await context.commit(Mutations.setStreamingQueryCostData, queryCostData);
    } catch (error) {
      context.commit(Mutations.setStreamingResults, {
        status: "VALIDATION_FAILED"
      });
      return;
    }
    if (
      context.state.queryCost.error == null &&
      context.state.queryCost.data.queryClass == "Normal"
    ) {
      await executeQueryHelper(context, query, {
        moduleName: "Streaming",
        mutations: Mutations,
        getters: context.getters,
        executeQueryFn: api.executeVideoInHomeQuery,
        moduleSpecificOptions: {
          showSum
        }
      });
    }
    else
      context.commit(Mutations.setStreamingResults, {
          status: "NOT_LOADED"
        });
  },
  [Actions.executeStreamingRoFQuery]: async context => {
    context.commit(Mutations.setStreamingRoFResults, {
      status: "LOADING",
      data: null
    });
    var r = await api.executeStreamingRoFQuery({
      ...context.getters.getStreamingRoFQuery,
      keys: context.getters.getStreamingRoFQuery.keys.map(key =>
        JSON.parse(key)
      )
    });
    r.average_frquency = r.average_frquency.map(cell => cell.toFixed(1).replace('.', ','))
    let selectedTarget = context.getters.getStreamingRoFQuery.target_group
    let group = selectedTarget.group == 'K' ? 'W' : selectedTarget.group
    let targetGroupLabel = group === 'O' && selectedTarget.other_value
      ? selectedTarget.other_value
      : `${group}${selectedTarget.age_from}-${selectedTarget.age_to}`;
    context.commit(Mutations.setStreamingRoFResults, {
      status: "LOADED",
      data: {
        ...r,
      },
      targetGroup: targetGroupLabel
    });
    setInitialRofTableColumns(context);
    setInitialRofTableRow(context);
    setRofTableColumns(context);
    setRofTableRows(context);
  },
  [Actions.getAllOtherTargetsRofResults]: async (context, payload) => {
    let otherRofResult = await api.executeStreamingRoFQuery({
      ...payload,
      keys: context.getters.getStreamingRoFQuery.keys.map(key =>
        JSON.parse(key)
      )
    });
    let group = payload.target_group.group == 'K' ? 'W' : payload.target_group.group;
    otherRofResult.targetGroup = group === 'O' && payload.target_group.other_value
      ? payload.target_group.other_value
      : `${group}${payload.target_group.age_from}-${payload.target_group.age_to}`;
    return otherRofResult;
  }
};

const getters = {
  getDefaultStreamingQuery: () => state.defaultStreamingQuery,
  getStreamingSumVisible: state => state.streamingSumVisible,
  getStreamingQuery: state => state.streamingQuery,
  getStreamingQueryForAPI: state => state.streamingQueryForAPI,
  getStreamingColumnTypes: state => state.streamingColumnTypes,
  getStreamingMeasures: state => state.streamingMeasures,
  getStreamingResults: state => state.streamingResults,
  getStreamingRoFResults: state => state.streamingRoFResults,
  getStreamingSelectedResults: state => state.streamingSelectedResults,
  getStreamingRoFQuery: state => state.streamingRoFQuery,
  getStreamingDomainGroups: state => state.streamingDomainGroups,
  getStreamingAllWithStarSelected: state => state.streamingAllWithStarSelected,
  getStreamingColumnFieldsOptions: state => state.streamingColumnFieldsOptions,
  getStreamingDisplayColumnFieldsOptions: state =>
    state.streamingDisplayColumnFieldsOptions,
  getStreamingRoFResultsLoadDetails: state =>
    state.streamingRoFResultsLoadDetails,
  getStreamingRofMaxFreqOptions: state => state.streamingRofMaxFreqOptions,
  getStreamingQueryCost: state => state.queryCost,
};

const mutations = {
  [Mutations.setStreamingSumVisible]: (state, payload) =>
    (state.streamingSumVisible = payload),
  [Mutations.setDefaultStreamingQuery]: (state, payload) =>
    (state.defaultStreamingQuery = payload),
  [Mutations.setStreamingMeasures]: (state, payload) =>
    (state.streamingMeasures = payload),
  [Mutations.setStreamingInitStatus]: (state, payload) =>
    (state.streamingInitStatus = payload),
  [Mutations.setStreamingStartdate]: (state, payload) =>
    (state.streamingQuery.start_date = payload),
  [Mutations.setStreamingEnddate]: (state, payload) =>
    (state.streamingQuery.end_date = payload),
  [Mutations.setStreamingColumnTypes]: (state, payload) =>
    (state.streamingColumnTypes = payload),
  [Mutations.setStreamingSelectedResults]: (state, payload) =>
    (state.streamingSelectedResults = payload),
  [Mutations.setStreamingDomainGroups]: (state, payload) =>
    (state.streamingDomainGroups = payload),
  [Mutations.setStreamingColumnFieldsOptions]: (state, payload) =>
    (state.streamingColumnFieldsOptions = payload),
  [Mutations.setStreamingQuery]: (state, payload) =>
    (state.streamingQuery = payload),
  [Mutations.setStreamingQueryForAPI]: (state, payload) =>
    (state.streamingQueryForAPI = payload),
  [Mutations.setStreamingRoFQuery]: (state, payload) =>
    (state.streamingRoFQuery = payload),
  [Mutations.setStreamingRoFResults]: (state, payload) =>
    (state.streamingRoFResults = payload),
  [Mutations.setStreamingResults]: (state, payload) =>
    (state.streamingResults = payload),
  [Mutations.setStreamingResultsColumns]: (state, payload) =>
    (state.streamingResults.data.columns = payload),
  [Mutations.setStreamingSelectedRowsIndex]: (state, payload) =>
    (state.streamingResults.data.selectedRowsIndex = payload),
  [Mutations.setStreamingAllWithStarSelected]: (state, payload) =>
    (state.streamingAllWithStarSelected = payload),
  [Mutations.setStreamingResultsCurrentPage]: (state, payload) =>
    (state.streamingResults.data.currentPage = payload),
  [Mutations.setStreamingRoFResultsLoadDetails]: (state, payload) =>
    (state.streamingRoFResultsLoadDetails = payload),

  [Mutations.setStreamingDisplayColumnFieldsOptions]: (state, payload) =>
    (state.streamingDisplayColumnFieldsOptions = payload),
  [Mutations.setStreamingQueryCostData]: (state, payload) =>
      (state.queryCost.data = payload),
};

export default {
  state,
  getters,
  mutations,
  actions
};
